import React, { useEffect } from 'react'
import Main from 'layouts/main'
import { Col, Row } from 'reactstrap'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { SIMULACAO } from 'store/modules/simulacao/types'
import { ProdutosSimulacao, SimulacaoCrefaz } from 'models/types'
import CardProduto from './components/CardProdutos'
import DetalhamentoProduto from './components/DetalhamentoProduto'
import ApresentacaoValores from './components/ApresentacaoValores'
import LoadingBasic from 'components/Loading/LoadingBasic'
import useRedux from 'hooks/useRedux'
import * as simulacaoActions from 'store/modules/simulacao/actions'
import ResumoContratacao from './components/Modals/ResumoContratacao'
import IndicacaoComponent from './components/Modals/IndicacaoComponent'
// import ModalIN100 from './components/Modals/ModalIN100'

const Simulacao = () => {
  const {
    loadingSimulacao,
    detalhamentoIsOpen,
    produtosDisponiveis,
    produtosSelecionados,
    produtoSelected,
    modalResumoContratacao,
    modalIndicacaoFgts,
    modalIN100,
    beneficios,
    jaSimulado
  } = useSelector<ApplicationState, SIMULACAO>((state) => state.simulacao)

  const { dispatch } = useRedux()

  function selecionaProduto(e: ProdutosSimulacao) {
    let produtosAtuaisSelecionados = [...produtosSelecionados]
    if (produtosAtuaisSelecionados.find((produto) => produto.id === e.id)) {
      produtosAtuaisSelecionados =
        produtosAtuaisSelecionados.filter((produto) => produto.id !== e.id) ||
        []
    } else {
      produtosAtuaisSelecionados.push(e)
    }
    dispatch(
      simulacaoActions.setProdutosSelecionados(produtosAtuaisSelecionados)
    )
  }

  function selecionaProdutoCrefaz(e: SimulacaoCrefaz) {
    const produtosAtuaisSelecionados = [...produtosSelecionados]
    const crefazIndex = produtosAtuaisSelecionados.findIndex(
      (produto) => produto.servico === 13
    )

    const produtoCrefaz = produtosAtuaisSelecionados[crefazIndex]
    const simulacoesCrefaz = produtoCrefaz?.simulacoesCrefaz || []

    const produtoJaSelecionado = simulacoesCrefaz.some(
      (simulacao) => simulacao.produtoId === e.produtoId
    )

    const produtosCrefazSelecionados = produtoJaSelecionado
      ? simulacoesCrefaz.filter(
          (simulacao) => simulacao.produtoId !== e.produtoId
        )
      : [...simulacoesCrefaz, e]

    dispatch(simulacaoActions.onCheckProdutoCrefaz(produtosCrefazSelecionados))
  }

  function toggleModal() {
    dispatch(
      simulacaoActions.toggleModalResumoContratacao(!modalResumoContratacao)
    )
  }

  useEffect(() => {
    dispatch(simulacaoActions.getClienteMatriculaCpfSaga())
  }, [dispatch])

  // useEffect(() => {
  //   if (beneficios.length && !jaSimulado) {
  //     dispatch(simulacaoActions.validaStatusIN100Saga())
  //   }
  // }, [dispatch, beneficios, jaSimulado])

  return (
    <Main>
      <ApresentacaoValores />

      <Row className="d-flex row-gap-20 flex-row-reverse">
        {loadingSimulacao ? (
          <LoadingBasic
            mainText="Estamos realizando a simulação dos produtos disponíveis para você!"
            secondaryText="Aguarde..."
          />
        ) : (
          <>
            {detalhamentoIsOpen &&
              produtosDisponiveis
                .filter((produto) => produto.servico !== 13)
                .map((produto, i) => {
                  const isSameServico =
                    produto.servico === produtoSelected?.servico
                  const isSameMatricula =
                    produto.matricula === produtoSelected?.matricula
                  if (isSameServico && isSameMatricula) {
                    return (
                      <Col md={5} key={i}>
                        <DetalhamentoProduto produto={produto} />
                      </Col>
                    )
                  }
                })}

            <Col>
              <Row className="d-flex row-gap-20">
                {produtosDisponiveis?.map((produto, i) => {
                  return (
                    <CardProduto
                      key={i}
                      produto={produto}
                      onCheck={(e) => {
                        selecionaProduto(e)
                      }}
                      onCheckCrefaz={(e) => {
                        selecionaProdutoCrefaz(e)
                      }}
                      checked={
                        !!produtosSelecionados.find(
                          (produtoSelecionado) =>
                            produtoSelecionado.id === produto.id
                        )
                      }
                    />
                  )
                })}
              </Row>
            </Col>
          </>
        )}
      </Row>
      <ResumoContratacao
        isOpen={modalResumoContratacao}
        onToggle={() => toggleModal()}
      />
      <IndicacaoComponent
        indicacao={modalIndicacaoFgts.indicacao}
        isOpen={modalIndicacaoFgts.isOpen}
        metodo={modalIndicacaoFgts.metodoFgts}
        toggle={() => {
          dispatch(simulacaoActions.cleanInfosModalIndicacao())
        }}
      />
      {/* <ModalIN100
        isOpen={modalIN100}
        toggle={() => {
          dispatch(simulacaoActions.toggleModalIN100(false))
        }}
      /> */}
    </Main>
  )
}

export default Simulacao
